const textData = {
  RU: {
    logo: "Totem логотип",
    header: {
      privacy: "Конфиденциальность",
      rules: "Правила",
      about: "О приложении",
      download: "Скачать",
    },
    hero: {
      title: "Магия людей вокруг",
      subtitle:
        "Гео-локационная социальная сеть для общения по интересам с людьми поблизости",
    },
    connect: {
      title: "Общайся с теми, кто рядом!",
      paragraph:
        "Totem Chat — твой путь к локальному общению! Наша социальная сеть позволяет вам легко и удобно общаться с людьми, находящимися в той же самой локации, что и вы. Вступай в  тусовку по интересам  или создавай свою.",
    },
    about: {
      cardTitle1: "Выбирай",
      cardTitle2: "Присоединяйся",
      cardTitle3: "Общайся",
      cardDesc1: "Ищи тусовки по своим интересам, находи людей близких по духу",
      cardDesc2:
        "Выбирай на карте чаты поблизости и присоединяйся к тусовке, знакомься и открывай для себя что-то новое",
      cardDesc3:
        "Общайся в чатах и будь в курсе о чем говорят другие, не пропускай интересные темы и будь в центре внимания",
    },
    whyTotem: {
      title: "В Totem Chat ты найдешь то, что ищешь!",
      desc: "Хочешь новых знакомых по своим интересам? Пожалуйста. Хочешь поиграть в настольный теннис с кем-то поблизости? Найдешь себе напарника в считанные минуты. Хочешь встретить свою любовь? Вступай в разные чаты, знакомься и общайся лично! Учишься в универе и стесняешься кого-то позвать на обед или нужна помощь с домашкой? Для этого есть Totem Chat. Скучно бывает только тем, у кого нет Тотема!",
    },
    download: {
      titleWhite: "Уже хочешь присоединиться?",
      titleYellow: "Скачивай приложение сейчас",
    },
    footer: {
      privacy: "Конфиденциальность",
      rules: "Правила",
      about: "О приложении",
      download: "Скачать",
      copyright: "2023 Totem Chat. Все права защищены",
    },
  },
  EN: {
    logo: "Totem logo",
    header: {
      privacy: "Privacy Policy",
      rules: "Rules",
      about: "About",
      download: "Download",
    },
    hero: {
      title: "The magic of the people around",
      subtitle: "Geo - location social network",
    },
    connect: {
      title: "Chat with those around you!",
      paragraph:
        "Totem Chat is your way to local communication! Our social network allows you to easily and conveniently communicate with people who are in the same location as you. Join an interest group or create your own.",
    },
    about: {
      cardDesc1:
        "Look for parties according to your interests, find people who are close in spirit",
      cardDesc2:
        "Choose chats nearby on the map and join the party, get to know each other and discover something new",
      cardDesc3:
        "Communicate in chats and be aware of what others are talking about, do not miss interesting topics and be in the center of attention",
    },
    whyTotem: {
      title: "In Totem Chat you will find what you are looking for!",
      desc: "Do you want to meet new people who share your interests? Please. Want to play table tennis with someone nearby? Find your partner in minutes. Do you want to meet your love? Join different chats, get acquainted and communicate personally! Do you study at the university and are embarrassed to invite someone to dinner or do you need help with homework? To do this, there is Totem Chat. Bored is only for those who do not have a Totem!",
    },
    download: {
      titleWhite: "Already want to join?",
      titleYellow: "Download the app now",
    },
    footer: {
      privacy: "Privacy Policy",
      rules: "Rules",
      about: "About",
      download: "Download",
      copyright: "2023 Totem Chat. All rights reserved",
    },
  },
};

export default textData;
